import { useContext } from "react";
import { DynamicIcon, IDynamicFormFullContext } from "../DynamicFormContracts";
import { DynamicFormFullContext } from "../Providers/DynamicFormFullContextProvider";

export default function useDynamicIcon(icon?: string): DynamicIcon | undefined {
  const context: IDynamicFormFullContext<any> = useContext(DynamicFormFullContext);
  if (!context) throw new Error("useDynamicFormValue should be used inside Dynamic Form");
  return icon && context.iconsMap ? context.iconsMap[icon] : undefined;
}
